import { isValidMobilePhone } from "@middleware/helpers";
import { getAge } from "@middleware/helpers/global/bilan";
import { getIMC } from "@middleware/helpers/global/graph";
import { IShemaMessage } from "@middleware/types";
import * as yup from "yup";

const getSchema = (messages: IShemaMessage, phoneIsRequired = false) => {
  const phoneValidation = yup
    .string()
    .test("validMobilePhone", messages.invalidPhoneMobile as string, (value) =>
      isValidMobilePhone(value ?? "", phoneIsRequired),
    );

  return yup.object().shape({
    name: yup.string().required(messages.requiredField),
    gender: yup.string().required(messages.chooseOption),
    birth_date: yup
      .date()
      .typeError(messages.requiredField ?? "")
      .required(messages.requiredField)
      .test("is-adult", messages.mustBeAdult ?? "", (value) => {
        const age = getAge(value.toDateString());

        return age >= 18;
      }),
    height: yup
      .number()
      .typeError(messages.numberPositive ?? "")
      .required(messages.requiredField)
      .min(80, messages.minHeight ?? "")
      .max(250, messages.maxHeight ?? "")
      .integer(messages.integerValue ?? ""),
    current_weight: yup
      .number()
      .typeError(messages.numberPositive ?? "")
      .required(messages.requiredField)
      .max(300, messages.weightIsOver300Kg ?? "")
      .test("imc", messages.imcMustBeLessThan18 ?? "", function (value) {
        return getIMC(value, this.parent.height) >= 18.5;
      }),
    desired_weight: yup
      .number()
      .min(40, messages.dangerWeight)
      .typeError(messages.numberPositive ?? "")
      .required(messages.requiredField)
      .test("is-lower", messages.chooseLowerWeight ?? "", function (value) {
        return value < this.parent.current_weight;
      }),
    health_pov: yup.string().required(messages.requiredField),
    activity_level: yup.string().required(messages.chooseOption),
    sleep_problems: yup.string().required(messages.chooseOption),
    diets_number: yup.string().required(messages.chooseOption),
    morning_fatigue: yup.string().required(messages.chooseOption),
    digestion_problems: yup.string().required(messages.chooseOption),
    email: yup
      .string()
      .email(messages.invalidEmail)
      .required(messages.requiredField),
    phone: phoneIsRequired
      ? phoneValidation.required(messages.requiredField)
      : phoneValidation,
    agreementCheck: yup.boolean().isTrue(messages.requiredField),
  });
};

export default getSchema;
